module.exports = __webpack_public_path__ + "static/media/cedula_posterior.5c996284.jpeg";